export const namespaces = {
    auth: 'auth/',
    layout: 'layout/',
    calendar: 'calendar/',
    adminCalendar: 'adminCalendar/'
}
